import { Stack } from "@mui/material";
import { RedisDetail } from "../types";
import Panel from "../components/Panel";
import StatTile from "../components/StatTile";

// ConnectivityPanel shows a dependency's live reachability + ping latency. Used for
// both Redis and the search backend (ES/OpenSearch) so the two detail pages match.
export default function ConnectivityPanel({ title, r, hint }: { title: string; r: RedisDetail; hint?: string }) {
    return (
        <Panel title={title}>
            <Stack direction="row" gap={2} flexWrap="wrap">
                <StatTile label="Reachable" value={r.reachable ? "Yes" : "No"} />
                <StatTile label="Ping latency" value={r.reachable ? `${r.pingMs.toFixed(2)} ms` : "—"} hint={hint} />
            </Stack>
        </Panel>
    );
}
